import request from '@/utils/request'

// 数据中心-目录管理-查询
export function getCenterTreeInfoTwo(query) {
    return request({
        url: '/datacenters/data/centers/getCenterTreeInfoTwo',
        method: 'get',
        params: query
    })
}

// 数据中心-模板-查询
export function getTemplateInfoList(query) {
    return request({
        url: '/datacenters/data/template/getTemplateInfoList',
        method: 'get',
        params: query
    })
}

// 数据中心-模板-详细指标
export function getTemplateInfoById(query) {
    return request({
        url: '/datacenters/data/template/getTemplateInfoById',
        method: 'get',
        params: query
    })
}

// 数据中心-模板-新增
export function newAddTemplateInfo(data) {
    return request({
        url: '/datacenters/data/template/newAddTemplateInfo',
        method: 'post',
        data: data
    })
}

// 数据中心-模板-新增2
export function newAddTemplateInfoTwo(data) {
    return request({
        url: '/datacenters/data/template/newAddTemplateInfoTwo',
        method: 'post',
        data: data
    })
}

// 数据中心-模板-编辑
export function editTemplateInfo(data) {
    return request({
        url: '/datacenters/data/template/editTemplateInfo',
        method: 'put',
        data: data
    })
}

// 数据中心-模板-删除
export function deleteTemplateInfo(query) {
    return request({
        url: '/datacenters/data/template/deleteTemplateInfo',
        method: 'delete',
        params: query
    })
}

// 数据中心-图标数据导出-前台
export function exportXls(query) {
    return request({
        url: '/datacenters/data/targetdata/exportXls',
        method: 'get',
        params: query,
        responseType: 'blob'
    })
}

// 数据中心-图标数据-前台
export function getTargetTableInfo(query) {
    return request({
        url: '/datacenters/data/targetdata/getTargetTableInfo',
        method: 'get',
        params: query
    })
}

